var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53319 5.60491C2.77736 5.50167 3.05899 5.61593 3.16223 5.86009L4.0047 7.85269L5.98381 7.01588C6.22799 6.91264 6.50962 7.02688 6.61286 7.27106C6.71609 7.51522 6.60185 7.79688 6.35766 7.90011L3.93644 8.92379C3.69227 9.02702 3.41064 8.91278 3.3074 8.66862L2.27801 6.23395C2.17477 5.98978 2.28902 5.70815 2.53319 5.60491Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42542 4.49174C6.21948 4.49174 4.42642 6.24899 4.37098 8.43416C4.36426 8.69912 4.14398 8.90853 3.87896 8.90181C3.61395 8.89509 3.40457 8.6748 3.41129 8.40978C3.47994 5.70387 5.699 3.53174 8.42542 3.53174C11.193 3.53174 13.4398 5.77855 13.4398 8.54604C13.4398 11.3191 11.1926 13.5604 8.42542 13.5604C6.7099 13.5604 5.20066 12.7017 4.29308 11.3946C4.14188 11.1768 4.19585 10.8777 4.4136 10.7266C4.63135 10.5753 4.93045 10.6293 5.08164 10.8471C5.81819 11.9079 7.03886 12.6004 8.42542 12.6004C10.6631 12.6004 12.4798 10.7881 12.4798 8.54604C12.4798 6.30874 10.6627 4.49174 8.42542 4.49174Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh1);
export default __webpack_public_path__ + "static/media/Refresh-1.585146eebc860f31cd1044d7fde6fcb2.svg";
export { ForwardRef as ReactComponent };